import * as React from "react";
import ThemeProviderContext from "../../contexes/themeProviderContext";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "../../state/store";
import * as quizAnswerActions from "../../state/quizAnswer/actions";
import { StyledButton } from "../styleComponents";
var SubmitButton = function SubmitButton() {
  var themeProvider = React.useContext(ThemeProviderContext);
  var dispatch = useDispatch();
  var submitLocked = useTypedSelector(function (state) {
    return state.quizAnswer.submitLocked;
  });
  var answerFormatIsValid = useTypedSelector(function (state) {
    return state.quizAnswer.answerFormatIsValid;
  });
  var pastDeadline = useTypedSelector(function (state) {
    return state.quizAnswer.pastDeadline;
  });
  var languageInfo = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  var noChangesAfterSuccessfulAnswer = useTypedSelector(function (state) {
    return state.quizAnswer.noChangesSinceSuccessfulSubmit;
  });
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var noChangesAfterLoading = useTypedSelector(function (state) {
    return state.quizAnswer.noChangesAfterLoading;
  });
  if (!languageInfo) {
    return React.createElement("div", null, "language not set");
  }
  var generalLabels = languageInfo.general;
  var buttonText = generalLabels.submitButtonLabel;
  if (noChangesAfterLoading && userQuizState && userQuizState.tries > 0) {
    buttonText = generalLabels.submitButtonAlreadyAnsweredLabel;
  }
  if (noChangesAfterSuccessfulAnswer) {
    buttonText = generalLabels.submitGeneralFeedbackLabel;
  }
  var handleSubmit = function handleSubmit() {
    dispatch(quizAnswerActions.submit());
  };
  var ThemedSubmitButton = themeProvider.submitButton;
  if (ThemedSubmitButton) {
    return React.createElement(ThemedSubmitButton, {
      disabled: submitLocked || !answerFormatIsValid,
      onClick: handleSubmit
    }, buttonText);
  }
  return React.createElement(StyledButton, {
    variant: "contained",
    color: "primary",
    disabled: submitLocked || pastDeadline || !answerFormatIsValid,
    onClick: handleSubmit,
    "aria-label": buttonText
  }, buttonText);
};
export default SubmitButton;